import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Drawer,
  FormControl,
  Link,
  MenuItem,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MuiTextField from "@mui/material/TextField";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useEffect, useMemo, useState } from "react";
import {
  businessDelete,
  checkoutGet,
  checkoutsGet,
  pdfInvoiceGet,
  refundAuthorization,
  refundCreate,
} from "../../api/api";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import React from "react";
import moment from "moment";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import UndoIcon from "@mui/icons-material/Undo";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { easepick, RangePlugin, AmpPlugin } from "@easepick/bundle";
import easepickCss from "@easepick/bundle/dist/index.css?url";
import easepickDarkCss from "../easepick.css?url";
import { useMedia } from "react-use";
let picker: easepick.Core | null = null;

import { MuiOtpInput } from "mui-one-time-password-input";

const formatNumber = (number: number) => {
  return new Intl.NumberFormat().format(number);
};

export const Checkouts = ({ selectedBusiness }: { selectedBusiness: any }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [selected, setSelected] = useState<any | null>(null);
  const [dateRange, setDateRange] = useState<{
    start: Date | null;
    end: Date | null;
  }>({
    start: null, //moment().add(-6, "days").startOf("day").toDate(),
    end: null, //moment().endOf("day").toDate(),
  });
  const [dateRangeName, setDateRangeName] = useState("No timeframe");
  const [total, setTotal] = useState(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [doSearch, setDoSearch] = useState<boolean>(false);
  const [refundDialogOpen, setRefundDialogOpen] = useState(false);
  const [refundAmount, setRefundAmount] = useState<number>(0);
  const [showAuthorization, setShowAuthorization] = useState<boolean>(false);
  const [authorizationCode, setAuthorizationCode] = useState<string>("");
  const theme = useTheme();
  const isDarkTheme = useMedia("(prefers-color-scheme: dark)");
  const mobileFullWidth = "calc(100vw - 32px)";
  const queryClient = useQueryClient();

  useEffect(() => {
    picker = new easepick.create({
      element: document.getElementById("datepicker")!,
      plugins: [RangePlugin, AmpPlugin],
      css: [easepickCss, easepickDarkCss],
      zIndex: 1,
      //format: 'DD/MM/YYYY',
    });

    picker.setDateRange(dateRange.start, dateRange.end);
    picker.on("select", (e) => {
      const { start, end } = e.detail;

      setDateRange({
        start,
        end,
      });
    });

    return () => {
      picker?.destroy();
    };
  }, []);

  const CustomStatusBar = (props: any) => {
    return (
      <div className="ag-status-bar-center">
        <div className="ag-status-name-value ag-status-panel ag-status-panel-total-row-count">
          <span className="label">Total Rows</span>:&nbsp;
          <span className="ag-status-name-value-value">{props.total}</span>
        </div>
      </div>
    );
  };

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  /*
  const { data: getUserAdminOfBusinessesResponse } = useQuery(
    'getUserAdminOfBusinesses',
    getUserAdminOfBusinesses,
    {
      enabled: true,
      refetchOnWindowFocus: false,
      suspense: true,
    },
  );

  const userAdminOfBusinesses = getUserAdminOfBusinessesResponse!.data;

  const [selectedBusinessId, setSelectedBusinessId] = useState<number>(
    userAdminOfBusinesses[0]?.id,
  );
  */

  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch: refetchCheckouts,
  } = useQuery(
    ["checkoutsGet", selectedBusiness?.id, dateRange, searchTerm],
    checkoutsGet(selectedBusiness?.id, dateRange, searchTerm),
    {
      enabled:
        (!!selectedBusiness && !!doSearch && !!searchTerm) ||
        dateRangeName !== "No timeframe",
      onSettled: () => {
        setDoSearch(false);
      },
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      keepPreviousData: true,
    }
  );
  const checkouts: any = (response as any)?.data?.checkouts;

  const {
    data: checkoutResponse,
    isLoading: checkoutIsLoading,
    error: checkoutError,
    refetch: refetchCheckout,
  } = useQuery(["checkoutGet", selected], checkoutGet(selected), {
    enabled: !!selected,
    refetchOnWindowFocus: false,
  });
  const checkout: any = (checkoutResponse as any)?.data;

  //setRefundAmount when checkout changes
  useEffect(() => {
    if (checkout) {
      setRefundAmount(checkout.amount - checkout.refundedAmount);
    }
  }, [checkout]);

  const closeRefundDialog = () => {
    setRefundDialogOpen(false);
    setShowAuthorization(false);
    setAuthorizationCode("");
  };

  const {
    mutateAsync: mutateAsyncRefund,
    error: mutateError,
    data: refundCreateResult,
    isLoading: refundMutateIsLoading,
  } = useMutation("refundCreate", refundCreate, {
    onSuccess: (response: any) => {
      if (response.data.status == "INITIATED" && response.data.id) {
        setShowAuthorization(true);
      } else {
        queryClient.invalidateQueries(["checkoutGet", "checkoutsGet"]);
        refetchCheckout();
        closeRefundDialog();
        alert("Error", "Refund creation failed. Please try again.");
      }
    },
    onError: (err: any) => {
      queryClient.invalidateQueries(["checkoutGet", "checkoutsGet"]);
      refetchCheckout();
      closeRefundDialog();
      alert("Error", err.message);
    },
    onSettled: () => {
      //queryClient.invalidateQueries(["checkoutGet", "checkoutsGet"]);
      refetchCheckout();
    },
  });

  const {
    mutateAsync: mutateAsyncAuthorization,
    error: authorizationMutateError,
    data: authorizationResult,
    isLoading: authorizationIsLoading,
  } = useMutation("authorization", refundAuthorization, {
    onSuccess: (response: any) => {
      if (response.result == "SUCCESS") {
        alert(
          "Success",
          response.provider == "credit-card"
            ? "Refund successful. It can take several business days for the refund to arrive to the customer. "
            : "Refund successful"
        );
        refetchCheckout();
        setRightDrawerOpen(false);
      }
      return;
    },
    /* 
    onError: (err: any) => {
      alert("Error", err.message);
    },
     */
    onSettled: () => {
      closeRefundDialog();
      //queryClient.invalidateQueries(["checkoutGet", "checkoutsGet"]);
      refetchCheckout();
    },
  });

  const dateFormat = "YYYY-MM-DD HH:mm";

  const handleDateChange = (event: SelectChangeEvent) => {
    setDateRangeName(event.target.value);
    setDoSearch(true);
    switch (event.target.value) {
      case "No timeframe":
        setDates(null, null);
        break;
      case "Today":
        setDates(
          moment().startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Yesterday":
        setDates(
          moment().add(-1, "d").startOf("day").toDate(),
          moment().add(-1, "d").endOf("day").toDate()
        );
        break;
      case "Last 7 days":
        setDates(
          moment().add(-6, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last 14 days":
        setDates(
          moment().add(-14, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last 28 days":
        setDates(
          moment().add(-28, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last 30 days":
        setDates(
          moment().add(-30, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last 90 days":
        setDates(
          moment().add(-90, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last 180 days":
        setDates(
          moment().add(-180, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last calendar year":
        setDates(
          moment().add(-1, "year").startOf("year").toDate(),
          moment().add(-1, "year").endOf("year").toDate()
        );
        break;
    }
  };

  const setDates = (start, end) => {
    setDateRange({
      start,
      end,
    });
    picker?.setDateRange(start, end);
  };

  const handleSearchTermChange = (event: { target: { value: any } }) => {
    setSearchTerm(event.target.value);
  };

  const { columnDefs, rowData } = useMemo(() => {
    if (!checkouts?.length) {
      return { rowData: [] };
    }
    const columnDefs: ColDef[] = [
      {
        field: "createdAt",
        headerName: "Time",
        sortable: true,
        initialSort: "desc",
        flex: 0.5,
        minWidth: 162,
        valueFormatter: ({ data }) => {
          return moment(data.createdAt).format(dateFormat);
        },
      },
      {
        field: "businessOrderId",
        headerName: "Business order ID",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 310,
        filter: true,
      },

      {
        field: "currency",
        headerName: "Currency",
        headerClass: "ag-narrow",
        cellClass: "ag-narrow",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 80,
        filter: true,
      },
      {
        field: "amount",
        headerName: "Total",
        headerClass: "ag-narrow text-align-right",
        cellClass: "ag-narrow text-align-right",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 80,
        filter: true,
      },

      {
        field: "paid",
        headerName: "Paid",
        headerClass: "ag-narrow",
        cellClass: "ag-narrow",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 80,
        filter: true,
        cellRenderer: ({ data }) => {
          return data.status == "SUCCESSFUL" ? <DoneIcon /> : <CloseIcon />;
        },
      },
      {
        field: "customerEmail",
        headerName: "Email",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 1.5,
        minWidth: 150,
        filter: true,
      },
      {
        field: "customerPhone",
        headerName: "Phone",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 180,
        filter: true,
      },
      {
        field: "providerId",
        headerName: "Payment method",
        headerClass: "ag-narrow",
        cellClass: "ag-narrow",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 140,
        filter: true,
      },
      {
        field: "id",
        headerName: "Checkout ID",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 200,
        filter: true,
      },

      /*       {
        field: "providerTransactionId",
        headerName: "Provider transaction ID",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 310,
        filter: true,
      }, */
    ];

    return { columnDefs, rowData: checkouts };
  }, [checkouts]);

  return (
    <>
      <Dialog
        open={refundDialogOpen}
        fullScreen={useMediaQuery(theme.breakpoints.down("sm"))}
        onClose={(event, reason) => {
          if (reason && reason == "backdropClick") return;
          closeRefundDialog();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ maxWidth: "100%!important" }}
      >
        <DialogTitle>
          {showAuthorization ? "Authorization" : "New refund"}
        </DialogTitle>
        <DialogContent
          dividers={useMediaQuery(theme.breakpoints.down("sm"))}
          sx={{ maxWidth: { xs: "100%", sm: "400px" } }}
        >
          {checkout && !showAuthorization && (
            <>
              {/* <Typography>
                Checkout ID: <br />
                {checkout.id}
              </Typography> */}
              <Typography sx={{ wordBreak: "break-all" }}>
                Order ID: {checkout.businessOrderId}
              </Typography>
              <Typography>Invoice number: {checkout.invoiceNumber}</Typography>
              <Typography>
                Refundable amount: {checkout.currency}{" "}
                {checkout.amount - checkout.refundedAmount}
              </Typography>
              <TextField
                autoFocus
                id="name"
                label={`Amount ${checkout.currency}`}
                type="number"
                size="small"
                fullWidth
                disabled={
                  refundMutateIsLoading ||
                  showAuthorization ||
                  checkout.providerId == "airtel-africa"
                }
                variant="outlined"
                error={refundAmount > checkout.amount - checkout.refundedAmount}
                helperText={
                  refundAmount > checkout.amount - checkout.refundedAmount
                    ? "Refund amount cannot be greater than the refundable amount"
                    : ""
                }
                defaultValue={refundAmount}
                onChange={(e) => setRefundAmount(Number(e.target.value))}
                sx={{ mt: "24px" }}
              />
            </>
          )}
          {showAuthorization && (
            <>
              <Typography>
                Please authorize the refund by entering the authorization code
                from the email you received within 2 minutes.
              </Typography>
              <Box>
                <MuiOtpInput
                  sx={{
                    mt: "24px",
                    widht: "auto",
                    gap: { xs: "6px", sm: "12px" },
                    maxWidth: { xs: "100%", sm: "400px" },
                  }}
                  length={5}
                  value={authorizationCode}
                  onChange={(newValue: any) => {
                    setAuthorizationCode(newValue);
                  }}
                />
              </Box>
              {!!authorizationMutateError && (
                <Typography color="error" sx={{ mt: "12px" }}>
                  {(authorizationMutateError as any).message}
                </Typography>
              )}
            </>
          )}
          <Box
            sx={{
              mt: "36px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              disabled={refundMutateIsLoading}
              onClick={() => closeRefundDialog()}
            >
              Cancel
            </Button>
            {!!checkout &&
              checkout.status === "SUCCESSFUL" &&
              !showAuthorization && (
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ width: "100px" }}
                  disabled={
                    refundAmount > checkout.amount - checkout.refundedAmount ||
                    refundAmount <= 0 ||
                    refundMutateIsLoading
                  }
                  onClick={async () => {
                    try {
                      const response = await mutateAsyncRefund({
                        amount: refundAmount,
                        checkoutSessionId: checkout.id,
                      });
                    } catch (error: any) {
                      /* 
                      refetchCheckout();
                      if (response) setRightDrawerOpen(false);
                      */
                      alert(error.error, error.message);
                    }
                  }}
                >
                  {!refundMutateIsLoading ? (
                    "Continue"
                  ) : (
                    <CircularProgress size={"19px"} />
                  )}
                </Button>
              )}
            {showAuthorization && (
              <Button
                variant="contained"
                color="primary"
                sx={{ width: "100px" }}
                disabled={
                  authorizationCode.length < 5 || authorizationIsLoading
                }
                onClick={async () => {
                  try {
                    await mutateAsyncAuthorization({
                      id: !!refundCreateResult
                        ? refundCreateResult.data?.id
                        : "",
                      authorizationCode,
                    });
                    /* 
                    refetchCheckout();
                    if (response) setRightDrawerOpen(false);
                   */
                  } catch (error: any) {
                    alert(error.error, error.message);
                  }
                }}
              >
                {!authorizationIsLoading ? (
                  "Refund"
                ) : (
                  <CircularProgress size={"19px"} />
                )}
              </Button>
            )}
          </Box>
        </DialogContent>
      </Dialog>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            setRightDrawerOpen(false);
          }}
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: { xs: "100vw", md: "65vw" },
              flex: 1,
              background: theme.palette.background.default,
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "12px 12px ",
                flexWrap: "wrap",
                alignItems: "center",
                padding: { xs: "12px 16px", sm: "12px 24px" },
                boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "12px 12px ",
                  flexWrap: "wrap",
                  alignItems: "center",
                  boxSizing: "border-box",
                }}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  /* disabled={isSubmitting} */
                  onClick={() => {
                    setRightDrawerOpen(false);
                  }}
                >
                  <ArrowBackIosNewOutlinedIcon sx={{ ml: -0.5, mr: 0.5 }} />
                  Back
                </Button>
                <Typography
                  variant="h1"
                  sx={{ fontSize: "1.3em", fontWeight: 500 }}
                >
                  Checkout details
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: "12px 12px ",
                  flexWrap: "wrap",
                  alignItems: "center",
                  boxSizing: "border-box",
                }}
              >
                {!!checkout && checkout.status === "SUCCESSFUL" && (
                  <>
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={() => {
                        pdfInvoiceGet(checkout.id);
                      }}
                    >
                      <ReceiptOutlinedIcon sx={{ ml: -0.5, mr: 0.5 }} />
                      PDF invoice
                    </Button>
                  </>
                )}
                {!!checkout &&
                  checkout.status === "SUCCESSFUL" &&
                  checkout.amount > checkout.refundedAmount && (
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={() => {
                        setRefundDialogOpen(true);
                      }}
                    >
                      <UndoIcon sx={{ ml: -0.5, mr: 0.5 }} />
                      Refund
                    </Button>
                  )}
              </Box>
            </Box>

            <Box
              sx={{
                padding: { xs: "12px 16px 24px", sm: "12px 24px 24px" },
              }}
            >
              {checkoutIsLoading && (
                <Box sx={{ textAlign: "center", mt: 6 }}>
                  <CircularProgress />
                </Box>
              )}
              {!!checkoutError && <>checkoutError</>}
              {!!checkout && (
                <Box
                  sx={{
                    display: "grid",
                    gridGap: "24px",
                    gridTemplateColumns: {
                      xs: "none",
                      sm: "repeat(auto-fit,minmax(330px,1fr))",
                    },
                  }}
                >
                  <Card>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Checkout
                      </Typography>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 500,
                            display: "inline",
                            wordBreak: "break-all",
                          }}
                        >
                          ID:{" "}
                        </Typography>
                        {checkout?.id}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Order ID:{" "}
                        </Typography>
                        {checkout?.businessOrderId}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Status:{" "}
                        </Typography>
                        {checkout?.status.charAt(0).toUpperCase() +
                          checkout?.status.slice(1).toLowerCase()}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Invoice number:{" "}
                        </Typography>
                        {checkout?.invoiceNumber}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Total:{" "}
                        </Typography>
                        {checkout?.currency} {formatNumber(checkout?.amount)}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Created at:{" "}
                        </Typography>
                        {moment(checkout?.createdAt).format("L LTS")}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Updated at:{" "}
                        </Typography>
                        {moment(checkout?.updatedAt).format("L LTS")}
                      </Box>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Customer
                      </Typography>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Email:{" "}
                        </Typography>
                        {checkout?.customerEmail}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Phone:{" "}
                        </Typography>
                        {checkout?.customerPhone}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Name:{" "}
                        </Typography>
                        {checkout?.customerName}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Country:{" "}
                        </Typography>
                        {checkout?.customerAddressCountry}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          State:{" "}
                        </Typography>
                        {checkout?.customerAddressState}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          City:{" "}
                        </Typography>
                        {checkout?.customerAddressCity}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Street address:{" "}
                        </Typography>
                        {checkout?.customerAddressStreet}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Postal code:{" "}
                        </Typography>
                        {checkout?.customerAddressPostalCode}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Tax ID:{" "}
                        </Typography>
                        {checkout?.customerTaxId}
                      </Box>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Operator
                      </Typography>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Name:{" "}
                        </Typography>
                        {checkout?.operator.name}
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 500,
                            display: "inline",
                            wordBreak: "break-all",
                          }}
                        >
                          ID:{" "}
                        </Typography>
                        {checkout?.operatorId}
                      </Box>
                      <Box sx={{ wordBreak: "break-all" }}>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Result URL:{" "}
                        </Typography>
                        {checkout?.resultUrl}
                      </Box>
                    </CardContent>
                  </Card>
                  <Card>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Payment
                      </Typography>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Method:{" "}
                        </Typography>
                        {checkout?.providerId}
                      </Box>
                      <Box sx={{ wordBreak: "break-all" }}>
                        <Typography
                          sx={{
                            fontWeight: 500,
                            display: "inline",
                            wordBreak: "break-all",
                          }}
                        >
                          Transaction ID:{" "}
                        </Typography>
                        {checkout?.providerTransactionId}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Note:{" "}
                        </Typography>
                        {checkout?.message}
                      </Box>
                    </CardContent>
                  </Card>
                  <Card>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Items
                      </Typography>

                      <Table aria-label="table" size="small">
                        <TableBody sx={{ wordBreak: "break-word" }}>
                          {checkout.items.map((item: any) => (
                            <TableRow key={item.itemId}>
                              <TableCell
                                sx={{
                                  paddingRight: "6px",
                                  paddingLeft: "0px",
                                  verticalAlign: "top",
                                  fontSize: { xs: "auto", sm: "1rem" },
                                }}
                              >
                                <Box>{item.name}</Box>
                                <Box>
                                  <span
                                  /*                           style={{
                                      opacity: 0.5,
                                    }} */
                                  >
                                    Qty{" "}
                                  </span>
                                  {formatNumber(item.quantity)} {item.unit}
                                </Box>
                              </TableCell>

                              <TableCell
                                align="right"
                                sx={{
                                  paddingLeft: "6px",
                                  paddingRight: "0px",
                                  verticalAlign: "top",
                                  fontSize: { xs: "auto", sm: "1rem" },
                                }}
                              >
                                <Box sx={{ wordBreak: "normal" }}>
                                  {item.currency}{" "}
                                  {formatNumber(item.amount * item.quantity)}
                                </Box>
                                {Number(item.quantity) > 1 && (
                                  <Box
                                    sx={{
                                      opacity: 0.5,
                                    }}
                                  >
                                    {item.currency} {formatNumber(item.amount)}{" "}
                                    each
                                  </Box>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                          {/* 
                                {order.ticketTypes.map((ticketType) => (
                                  <TableRow
                                    key={ticketType.id}
                                    sx={{
                                      '&:last-child td, &:last-child th': {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    <TableCell>{ticketType.name}</TableCell>
                                    <TableCell align="center">
                                      {ticketType.quantity}
                                    </TableCell>
                                    <TableCell align="right">
                                      {ticketType.price} RWF
                                    </TableCell>
                                  </TableRow>
                                ))}
                                 */}
                        </TableBody>
                      </Table>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          flexGrow: 0,
                          alignItems: "center",
                          gap: 1,
                          mt: "-2px",
                        }}
                      >
                        <Typography variant="h5">Refunds</Typography>

                        {!!checkout &&
                          checkout.status === "SUCCESSFUL" &&
                          checkout.amount > checkout.refundedAmount && (
                            <Button
                              color="primary"
                              onClick={() => {
                                setRefundDialogOpen(true);
                              }}
                            >
                              <AddIcon sx={{ ml: -0.5, mr: 0.5 }} />
                              New refund
                            </Button>
                          )}
                      </Box>
                      <Table aria-label="table" size="small">
                        <TableBody
                          sx={{ wordBreak: "break-word", fontSize: "1rem" }}
                        >
                          {checkout.refunds.map((refund: any) => (
                            <TableRow key={refund.id}>
                              <TableCell
                                sx={{
                                  paddingRight: "6px",
                                  paddingLeft: "0px",
                                  verticalAlign: "top",
                                  fontSize: { xs: "auto", sm: "1rem" },
                                }}
                              >
                                <Box>
                                  {moment(refund.createdAt).format("L LTS")}
                                </Box>
                                <Box>{refund.initiatorUser?.email}</Box>
                              </TableCell>

                              <TableCell
                                align="right"
                                sx={{
                                  paddingLeft: "6px",
                                  paddingRight: "0px",
                                  verticalAlign: "top",
                                  fontSize: { xs: "auto", sm: "1rem" },
                                }}
                              >
                                <Box>
                                  {refund.currency}{" "}
                                  {formatNumber(refund.amount)}
                                </Box>
                                <Box>
                                  {refund?.status.charAt(0).toUpperCase() +
                                    refund?.status.slice(1).toLowerCase()}
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                          {/* 
                                {order.ticketTypes.map((ticketType) => (
                                  <TableRow
                                    key={ticketType.id}
                                    sx={{
                                      '&:last-child td, &:last-child th': {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    <TableCell>{ticketType.name}</TableCell>
                                    <TableCell align="center">
                                      {ticketType.quantity}
                                    </TableCell>
                                    <TableCell align="right">
                                      {ticketType.price} RWF
                                    </TableCell>
                                  </TableRow>
                                ))}
                                 */}
                        </TableBody>
                      </Table>
                    </CardContent>
                  </Card>
                  <Card>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Business
                      </Typography>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Legal name:{" "}
                        </Typography>
                        {checkout?.business?.legalName}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Email:{" "}
                        </Typography>
                        {checkout?.business?.email}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Phone:{" "}
                        </Typography>
                        {checkout?.business?.phone}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Country:{" "}
                        </Typography>
                        {checkout?.business?.country}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          State:{" "}
                        </Typography>
                        {checkout?.business?.state}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          City:{" "}
                        </Typography>
                        {checkout?.business?.city}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Street address:{" "}
                        </Typography>
                        {checkout?.business?.streetAddress}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Postal code:{" "}
                        </Typography>
                        {checkout?.business?.postalCode}
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, display: "inline" }}>
                          Tax ID:{" "}
                        </Typography>
                        {checkout?.business?.taxId}
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              )}
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      {/* 
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Deletion confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {refundCreateResult?.message || ''} 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
       */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: "1",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexShrink: 0,
            flexGrow: 0,
            alignItems: "center",
            gap: "8px 12px",
            minHeight: "56px",
            maxWidth: "100vw",
            flexWrap: "wrap",
            padding: "8px 0 8px",
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: "1.25rem",
            }}
          >
            Checkouts
          </Typography>
          <Box className="field-with-icon" sx={{ position: "relative" }}>
            {dateRangeName != "Custom" && (
              <FormControl
                sx={{
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                <Select
                  size="small"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={dateRangeName}
                  onChange={handleDateChange}
                  sx={{
                    width: { xs: mobileFullWidth, sm: "210px" },
                  }}
                >
                  <MenuItem value={"No timeframe"}>No timeframe</MenuItem>
                  <MenuItem value={"Today"}>Today</MenuItem>
                  <MenuItem value={"Yesterday"}>Yesterday</MenuItem>
                  <MenuItem value={"Last 7 days"}>Last 7 days</MenuItem>
                  <MenuItem value={"Last 14 days"}>Last 14 days</MenuItem>
                  <MenuItem value={"Last 28 days"}>Last 28 days</MenuItem>
                  <MenuItem value={"Last 30 days"}>Last 30 days</MenuItem>
                  <MenuItem value={"Last 90 days"}>Last 90 days</MenuItem>
                  <MenuItem value={"Last 180 days"}>Last 180 days</MenuItem>
                  <MenuItem value={"Last calendar year"}>
                    Last calendar year
                  </MenuItem>
                  <MenuItem value={"Custom"}>Custom range</MenuItem>
                </Select>
              </FormControl>
            )}
            <CalendarMonthOutlinedIcon
              className="field-icon"
              sx={{ position: "absolute", top: "7px", left: "10px" }}
            />
            <Box
              sx={{
                display: dateRangeName == "Custom" ? "block" : "none",
                position: "relative",
              }}
            >
              <MuiTextField
                size="small"
                id="datepicker"
                fullWidth
                sx={{
                  width: { xs: mobileFullWidth, sm: "260px" },
                  display: dateRangeName == "Custom" ? "block" : "none",
                }}
              />
              <ArrowDropDownIcon
                sx={{
                  position: "absolute",
                  top: "7px",
                  right: "7px",
                  opacity: isDarkTheme ? 1 : 0.645,
                  pointerEvents: "none",
                }}
              />
            </Box>
          </Box>
          <Box
            className="field-with-icon"
            sx={{ position: "relative", width: { xs: "100%", sm: "auto" } }}
          >
            <FormControl
              sx={{
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <TextField
                id="outlined-basic"
                /* label="Checkout search" */
                placeholder="Order ID, Checkout ID, Phone or Email"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchTermChange}
                onKeyDown={(e: any) => {
                  if (e.key === "Enter") {
                    setDoSearch(true);
                    e.preventDefault();
                  }
                }}
                sx={{
                  width: { xs: "100%", sm: "350px" },
                }}
              />
            </FormControl>

            <SearchOutlinedIcon
              className="field-icon"
              sx={{ position: "absolute", top: "7px", left: "10px" }}
            />
          </Box>
          {/*           
          <MuiTextField
            size="small"
            id="datepicker"
            sx={{
              ml: "6px",
              minWidth: "200px",
            }}
          />
 */}
          {/*
          <Button
            color="primary"
            onClick={() => {
              setSelected(null);
              setRightDrawerOpen(true);
            }}
          >
            <AddIcon sx={{ ml: -0.5, mr: 0.5 }} />
            Add new
          </Button>
          */}
          {/*          
          <Button
            color="primary"
            onClick={() => {
              setDateRange({
                start: moment().subtract(1, "months").startOf("month").toDate(),
                end: moment().subtract(1, "months").endOf("month").toDate(),
              });
              picker?.setDateRange(
                moment().subtract(1, "months").startOf("month").toDate(),
                moment().subtract(1, "months").endOf("month").toDate()
              );
            }}
          >
            Last month
          </Button>
 */}
          {/*
          <Button
            color="primary"
            onClick={() => {
              setDateRange({
                start: moment().subtract(1, 'd').toDate(),
                end: moment().subtract(1, 'd').toDate(),
              });
              picker?.setDateRange(
                moment().subtract(1, 'd').toDate(),
                moment().subtract(1, 'd').toDate(),
              );
            }}
          >
            Yesterday
          </Button>
          */}
        </Box>
        <Card
          className="ag-theme-material"
          sx={{
            borderRadius: 0,
            margin: "0 -16px -16px",
            display: "flex",
            overflow: "hidden",
            flexGrow: 1,
            height: "100%",
            boxShadow: "none !important",
          }}
        >
          {isFetching && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          )}

          <Box sx={{ display: isFetching ? "none !important" : "block" }}>
            <AgGridReact
              className="ag-pointer-row"
              rowData={rowData}
              pagination={true}
              floatingFiltersHeight={50}
              paginationAutoPageSize={true}
              columnDefs={columnDefs}
              /* 
            frameworkComponents={{
              customStatusBar: CustomStatusBar,
            }}
            statusBar={{
              statusPanels: [
                {
                  statusPanel: "customStatusBar",
                  align: "center",
                  statusPanelParams: { total: total },
                },
              ],
            }}
             */
              onRowClicked={({ data }) => {
                setSelected(data.id);
                setRightDrawerOpen(true);
              }}
            ></AgGridReact>
          </Box>
        </Card>
      </Box>
    </>
  );
};

export default Checkouts;
